import { ReactElement } from "react";
import Status from "./Status";

type Props = {
  title: string;
  onlyValue?: boolean;
  icon?: ReactElement;
  original: any;
  tag?: any;
};

export default function Item(props: Props) {
  const { icon, title, original, onlyValue = false, tag } = props;
  return (
    <div className="flex">
      {/* {icon} */}
      <div className={"ml-3"}>
        <div className="text-[#373737] font-medium text-sm flex items-center">
          {title}
        </div>

        {onlyValue ? (
          original
        ) : (
          <div className="text-sm font-normal text-[#626262]">{original}</div>
        )}
        {tag && (
          <div className="mt-2">
            {tag?.visible?.isVisible && (
              <Status label={tag?.label} value={tag?.value || "NA"} />
            )}
          </div>
        )}
      </div>
    </div>
  );
}
